module.exports = __webpack_public_path__ + "img/yuanmingyuan big (7).2776da5a.jpg";